<template>
  <div class="tab-info">
    <n-divide class="tools" style="margin-bottom: 10px;">
      <div></div>
      <div><n-button v-if="editable" @click="$var('add', true)">Добавить администратора</n-button></div>
    </n-divide>
    <n-table :data="admins" :columns="columns" :loading="$var('loading')">
      <template #tools="{item}">
        <n-button v-if="admins.length > 1 && editable" icon="minus" flat round @click="remove(item)" />
      </template>
    </n-table>
  
    <n-modal v-if="$var('add')" :loading="$var('loadingAdd')" @close="$var('add', false)">
      <n-select :data="users" option-title="fullName" selected-title="fullName" item-value="id" :value.sync="newAdmin" title="Пользователь" />
      <n-button style="margin-top: 15px" color="primary" wide @click="submit">Добавить администратора</n-button>
    </n-modal>
  </div>
</template>

<script>
export default {
  name: 'TabAdmins',
  props: [ 'editable', ],
  data() {
    return {
      users: [],
      newAdmin: null,
      admins: [],
      columns: [
        { title: 'ФИО', name: 'fullName', },
        { title: 'ИИН', name: 'iin', },
        { title: 'E-mail', name: 'email', },
        { title: 'Телефон', name: 'phone', },
        { title: 'Должность', name: 'position', },
        { title: '', name: 'tools', align: 'center', width: '100px', },
      ],
    }
  },
  computed: {
    companyId() {
      return this.$route.query.id
    },
  },
  created() {
    this.load()
    this.$form.init({
      iin: '',
      email: '',
      position: '',
    })
    this.$form.rules({
      iin: [ 'required', ],
      email: [ 'required', ],
      position: [ 'required', ],
    })
  },
  methods: {
    load() {
      this.$var('loading', true)
      $api.companies.workers.get(this.companyId).filter({ admin: true, }).then((response) => {
        this.admins = response.data.content
        this.$var('loading', false)
      })
      $api.companies.workers.get(this.companyId).filter({ admin: false, }).then((response) => {
        this.users = response.data.content
      })
    },
    submit() {
      this.$var('loadingAdd', true)
      $api.companies.workers.admin(this.companyId, this.newAdmin.id).then(() => {
        this.load()
      }).finally(() => {
        this.$var('add', false)
        this.$var('loadingAdd', false)
      })
    },
    remove(user) {
      this.$var('loading', true)
      $api.companies.workers.admin(this.companyId, this.newAdmin.id).then(() => {
        this.load()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .tab-info {
    font-size: .9em;
  }
</style>
